import { Layers } from "lucide-react";
import { cn } from "@wa/ui";
import { useT } from "../../../../i18n/I18nProvider";
import { IconBtn } from "../../../ui";

/**
 * The switch between the flat call log and the folded one.
 *
 * It sits in the list pane's head beside the density toggle, because both
 * answer the same question - how should this list be shaped - and an operator
 * looking for one will find the other.
 *
 * A pressed toggle rather than a menu, for the reason `DensityToggle` gives:
 * there are two states, the change is visible the instant it happens, and a
 * menu would cost two clicks to say one thing. The accessible name stays the
 * same in both states and `aria-pressed` carries whether it is on, which is
 * what a screen reader expects from a switch.
 */
export function ThreadToggle({ threaded, onToggle }: { threaded: boolean; onToggle: () => void }) {
  const t = useT();

  return (
    <IconBtn
      className={cn(threaded && "is-on")}
      onClick={onToggle}
      aria-pressed={threaded}
      aria-label={t("calls.thread.toggle")}
      title={threaded ? t("calls.thread.toFlat") : t("calls.thread.toThreaded")}
    >
      <Layers className="size-4" />
    </IconBtn>
  );
}
